import { useMutation as p } from "react-query";
import { useEnvironment as u } from "../../../../../features/common/hooks/environment/useEnvironment.js";
import m from "../customization/useCustomization.js";
function h() {
  const {
    servicesBaseUrl: n,
    servicesToken: i
  } = u(), {
    configuration: o,
    getScopeLocations: s
  } = m();
  return p(
    "address_validation",
    async ({
      serviceType: t,
      latitude: e,
      longitude: r,
      address: a
    }) => {
      if (o === void 0)
        throw new Error("Could not get configuration object");
      const c = s(t).map((d) => d.id) ?? [];
      return (await fetch(`${n}/v2/shop-address-validation/`, {
        method: "POST",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: `token ${i}`
        },
        body: JSON.stringify({
          service_type: t,
          address: {
            latitude: e,
            longitude: r,
            address: a
          },
          domain: o.settings.configuration.domain,
          scope: {
            locations: c
          }
        })
      })).json();
    }
  );
}
export {
  h as useAddressValidation
};
//# sourceMappingURL=useAddressValidation.js.map
